/*
 * Redirect via Netlify > https://markus.oberlehner.net/blog/using-netlify-redirects-to-proxy-images-hosted-on-a-third-party-image-provider-or-a-headless-cms
 */
export const redirectPath = "/images/";

export const ILLUSTRATION_THUMBNAIL_PATH =
  "images/c_thumb,h_220,w_180/annotation-app/illustrations/";

export const ILLUSTRATION_ADMIN_THUMBNAIL_PATH =
  "images/c_scale,w_180/annotation-app/illustrations/";

export const ILLUSTRATION_ADMIN_PREVIEW_PATH =
  "images/c_scale,w_320/annotation-app/illustrations/";

export const SIZE_SMALL = "small";

export const SIZE_MEDIUM = "medium";

export const SIZE_LARGE = "large";

export const DEFAULT_AXIS_DIRECTION = "horizontal";

export const DEFAULT_COLOR = "black";

export const DEFAULT_SHAPE = "rectangle";

export const DEFAULT_SIZE = SIZE_SMALL;

export const LINE_THICKNESS_0 = 0;
export const LINE_THICKNESS_1 = 2;
export const LINE_THICKNESS_2 = 4;
export const LINE_THICKNESS_3 = 6;
export const LINE_THICKNESS_4 = 32;
export const LINE_THICKNESS_5 = 64;
export const LINE_THICKNESS_6 = 96;

export const RADIAN = 6.28318;

export const ROLE_ADMIN = "admin";

export const ROLE_DM = "dm";

export const ROLE_USER = "user";

export const ROLE_OWNER = "owner";

export const TOOL_ARROW = "arrow";

export const TOOL_CHANGE_IMAGE = "change-image";

export const TOOL_ELLIPSE = "ellipse";

export const TOOL_ERASE_ALL = "erase-all";

export const TOOL_ERASER = "eraser";

export const TOOL_PEN = "pen";

export const TOOL_RECTANGLE = DEFAULT_SHAPE;

export const TOOL_CATALOGUE = "catalogue";

export const TOOL_SHAPE = "shape";

export const TOOL_TEXT = "text";

export const VIEWPORT_PHONE = "phone";

export const VIEWPORT_TABLET = "tablet";

export const VIEWPORT_LAPTOP = "laptop";

export const VIEWPORT_WIDESCREEN = "wide";

export const EVENTS_TOUCH = {
  down: "touchstart",
  move: "touchmove",
  up: "touchend",
};

export const EVENTS_POINTER = {
  down: "pointerdown",
  move: "pointermove",
  up: "pointerup",
};

export const IMAGE_CATALOGUE = "image-catalogue";

export const MODAL_SHARE = "modal-share";

export const MODAL_FEEDBACK = "modal-feedback";
